/* ==========================================================================
   nb-product.js — Nuttet Baby produktside

   Fire ting:
     1) Galleri        klik paa miniature skifter hovedbillede
     2) Varianter      chips/swatches/pills -> pris, lager, billede, URL, CTA
     3) Tilbehoer      afkrydsningsfelter laegges med som ekstra varelinjer
     4) Sticky bar     vises naar hovedknappen er rullet ud af viewporten

   INGEN TEKST I DENNE FIL. Alle strenge kommer fra data-attributter sat i
   sections/nb-product-main.liquid og sections/nb-product-sticky.liquid.
   Alle beloeb er formateret i Liquid; kun linjetotalen regnes her, og den
   formateres af window.NBCart.formatMoney med butikkens eget money_format.

   Vi roerer ikke nb-cart.js. Efter en vellykket tilfoejelse kaldes dens
   offentlige API (NBCart.refresh) og eventet nb-cart-open udsendes, saa
   kurv-draweren aabner praecis som fra et produktkort.

   Idempotent: init koerer paa DOMContentLoaded og paa shopify:section:load,
   og hvert element bliver kun bundet én gang.
   ========================================================================== */

(function () {
  'use strict';

  var ADDED_FEEDBACK_MS = 1200;

  /* ------------------------------------------------------------------ *
     Hjaelpere
     ------------------------------------------------------------------ */
  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function qs(root, selector) {
    return root ? root.querySelector(selector) : null;
  }

  function qsa(root, selector) {
    return root ? toArray(root.querySelectorAll(selector)) : [];
  }

  function attr(el, name, fallback) {
    if (!el) return fallback;
    var value = el.getAttribute(name);
    return value === null || value === '' ? fallback : value;
  }

  function money(cents, format) {
    if (window.NBCart && typeof window.NBCart.formatMoney === 'function') {
      return window.NBCart.formatMoney(cents, format);
    }
    return null;
  }

  /* Erstatter {token} i en skabelon fra en data-attribut. */
  function fill(template, token, value) {
    if (!template) return '';
    return template.split('{' + token + '}').join(value);
  }

  /* ------------------------------------------------------------------ *
     Produktsektionen
     ------------------------------------------------------------------ */
  function readVariants(root) {
    var script = qs(root, '[data-nb-variant-json]');
    if (!script) return [];
    try {
      var data = JSON.parse(script.textContent);
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  /* Den valgte vaerdi pr. option, i optionernes egen raekkefoelge. */
  function selectedOptions(root) {
    return qsa(root, '[data-nb-option]').map(function (group) {
      var active = qs(group, '.nb-pdp__value.is-active');
      return active ? active.getAttribute('data-nb-option-value') : null;
    });
  }

  function matchVariant(variants, values) {
    if (!values.length) return variants[0] || null;
    for (var i = 0; i < variants.length; i++) {
      var options = variants[i].options || [];
      var hit = true;
      for (var j = 0; j < values.length; j++) {
        if (values[j] === null) continue;
        if (options[j] !== values[j]) {
          hit = false;
          break;
        }
      }
      if (hit) return variants[i];
    }
    return null;
  }

  function quantityOf(root) {
    var input = qs(root, '[data-nb-pdp-qty-input]');
    if (!input) return 1;
    var value = parseInt(input.value, 10);
    if (isNaN(value) || value < 1) value = 1;
    return value;
  }

  function upsellInputs(root) {
    return qsa(root, '[data-nb-upsell-input]');
  }

  /* ---------------------------------------------------------------- *
     Galleri
     ---------------------------------------------------------------- */
  function showMedia(root, mediaId) {
    if (!mediaId) return;
    var id = String(mediaId);

    qsa(root, '[data-nb-stage-img]').forEach(function (img) {
      var isActive = img.getAttribute('data-nb-media-id') === id;
      img.classList.toggle('is-active', isActive);
      if (isActive && img.getAttribute('loading') === 'lazy') {
        img.setAttribute('loading', 'eager');
      }
    });

    qsa(root, '[data-nb-thumb]').forEach(function (thumb) {
      var isActive = thumb.getAttribute('data-nb-media-id') === id;
      thumb.classList.toggle('is-active', isActive);
      thumb.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  /* ---------------------------------------------------------------- *
     Pris, lager og knap
     ---------------------------------------------------------------- */
  function paintPrice(root, variant) {
    var host = qs(root, '[data-nb-price]');
    if (!host || !variant) return;

    var current = qs(host, '.nb-price__current');
    if (current) current.textContent = variant.price_money;

    var wrapper = qs(host, '.nb-price');
    var onSale = !!variant.compare_money;
    if (wrapper) wrapper.classList.toggle('nb-price--onsale', onSale);

    var compare = qs(host, '.nb-price__compare');
    if (compare) {
      compare.textContent = onSale ? variant.compare_money : '';
      compare.hidden = !onSale;
    }

    /* "Fra" giver kun mening, saa laenge ingen variant er valgt. */
    var from = qs(host, '.nb-price__from');
    if (from) from.hidden = true;

    var style = host.getAttribute('data-nb-save-style');

    if (style === 'percent') {
      var pctBadge = qs(host, '.nb-badge--sale');
      if (pctBadge) {
        pctBadge.textContent = onSale
          ? fill(host.getAttribute('data-nb-i18n-save-pct'), 'percent', variant.save_percent)
          : '';
        pctBadge.hidden = !onSale;
      }
    }

    if (style === 'amount') {
      var amountBadge = qs(host, '[data-nb-save-amount]');
      if (amountBadge) {
        amountBadge.textContent = onSale
          ? fill(host.getAttribute('data-nb-i18n-save-amount'), 'amount', variant.save_money)
          : '';
        amountBadge.hidden = !onSale;
      }
    }
  }

  function paintStock(root, variant) {
    var el = qs(root, '[data-nb-stock]');
    if (!el || !variant) return;
    var inStock = ('in_stock' in variant) ? !!variant.in_stock : !!variant.available;
    el.setAttribute('data-nb-state', inStock ? 'in' : 'out');
    el.textContent = inStock
      ? attr(el, 'data-nb-label-in-stock', '')
      : attr(el, 'data-nb-label-sold-out', '');
  }

  function paintButtons(root, variant) {
    var buttons = qsa(root, '[data-nb-pdp-add]').concat(qsa(document, '[data-nb-sticky-cta]'));
    var available = !!(variant && variant.available);

    buttons.forEach(function (button) {
      if (button.getAttribute('data-nb-state') === 'adding') return;
      button.disabled = !available;
      if (available) button.removeAttribute('aria-disabled');
      else button.setAttribute('aria-disabled', 'true');

      var label = qs(button, '[data-nb-cta-text]');
      if (label) {
        label.textContent = available
          ? attr(button, 'data-nb-label-default', label.textContent)
          : attr(button, 'data-nb-label-soldout', label.textContent);
      }

      /* Stregen og beloebet vises og skjules ALTID sammen — ellers staar
         der "Laeg i kurv —" med en dinglende tankestreg. */
      var sum = qs(button, '[data-nb-cta-sum]');
      var total = qs(button, '[data-nb-cta-total]');
      if (sum) sum.hidden = !available;
      if (total) total.hidden = !available;
    });
  }

  /* Wrapperen om streg + total. Falder tilbage til elementet selv, saa
     aeldre markup uden wrapper stadig virker. */
  function sumHost(total) {
    if (!total) return null;
    return (total.closest && total.closest('[data-nb-cta-sum]')) || total;
  }

  /* Linjetotal = variantpris x antal + afkrydset tilbehoer. */
  function paintTotal(root, variant) {
    var total = qs(root, '[data-nb-cta-total]');
    if (!total || !variant) return;
    var host = sumHost(total);

    var sum = variant.price * quantityOf(root);
    upsellInputs(root).forEach(function (input) {
      if (!input.checked) return;
      var price = parseInt(input.getAttribute('data-nb-upsell-price'), 10);
      if (!isNaN(price)) sum += price;
    });

    /* Kan beloebet ikke formateres, skjules baade streg og total. */
    var text = money(sum, root.getAttribute('data-nb-money-format'));
    if (text === null) {
      total.hidden = true;
      host.hidden = true;
      return;
    }
    total.textContent = text;
    total.hidden = !variant.available;
    host.hidden = !variant.available;
  }

  function paintSticky(root, variant) {
    var bar = document.querySelector('[data-nb-sticky]');
    if (!bar || !variant) return;

    var price = qs(bar, '[data-nb-sticky-price]');
    if (price) price.textContent = variant.price_money;

    var title = qs(bar, '[data-nb-sticky-variant]');
    if (title) title.textContent = variant.title;

    var img = qs(bar, '[data-nb-sticky-img]');
    if (img && variant.image) {
      img.src = variant.image;
      img.removeAttribute('srcset');
    }
  }

  function paintOptionLabels(root) {
    qsa(root, '[data-nb-option]').forEach(function (group) {
      var current = qs(group, '[data-nb-option-current]');
      if (!current) return;
      var active = qs(group, '.nb-pdp__value.is-active');
      current.textContent = active ? active.getAttribute('data-nb-option-value') : '';
    });
  }

  function pushUrl(root, variant) {
    if (!variant || !window.history || !window.history.replaceState) return;
    var base = root.getAttribute('data-nb-product-url');
    if (!base) return;
    try {
      var url = new URL(base, window.location.origin);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    } catch (e) {
      /* Aeldre browser uden URL-konstruktoer: URL'en staar bare stille. */
    }
  }

  function applyVariant(root, options) {
    var opts = options || {};
    var variants = root.__nbVariants || [];
    var variant = matchVariant(variants, selectedOptions(root));

    root.__nbVariant = variant;

    var idInput = qs(root, '[data-nb-variant-id]');
    if (idInput && variant) idInput.value = variant.id;

    paintOptionLabels(root);
    if (!variant) {
      paintButtons(root, null);
      return;
    }

    paintPrice(root, variant);
    paintStock(root, variant);
    paintButtons(root, variant);
    paintTotal(root, variant);
    paintSticky(root, variant);
    if (variant.media_id) showMedia(root, variant.media_id);
    if (opts.updateUrl !== false) pushUrl(root, variant);
  }

  /* ---------------------------------------------------------------- *
     Laeg i kurv
     ---------------------------------------------------------------- */
  function collectItems(root) {
    var variant = root.__nbVariant;
    if (!variant) return [];

    var items = [{ id: variant.id, quantity: quantityOf(root) }];
    upsellInputs(root).forEach(function (input) {
      if (!input.checked) return;
      var id = parseInt(input.getAttribute('data-nb-upsell-variant'), 10);
      if (!isNaN(id)) items.push({ id: id, quantity: 1 });
    });
    return items;
  }

  function showError(root, message) {
    var el = qs(root, '[data-nb-pdp-error]');
    if (!el) return;
    if (!message) {
      el.textContent = '';
      el.hidden = true;
      return;
    }
    el.textContent = message;
    el.hidden = false;
  }

  function errorText(root, error) {
    var data = error && error.data;
    if (data && typeof data.description === 'string' && data.description) return data.description;
    if (data && typeof data.message === 'string' && data.message) return data.message;
    return root.getAttribute('data-nb-i18n-error') || '';
  }

  function setButtonState(button, state) {
    var label = qs(button, '[data-nb-cta-text]');
    if (state === 'adding') {
      button.setAttribute('data-nb-state', 'adding');
      button.disabled = true;
      if (label) label.textContent = attr(button, 'data-nb-label-adding', label.textContent);
      return;
    }
    if (state === 'added') {
      button.setAttribute('data-nb-state', 'added');
      if (label) label.textContent = attr(button, 'data-nb-label-added', label.textContent);
      return;
    }
    button.removeAttribute('data-nb-state');
    button.disabled = false;
    if (label) label.textContent = attr(button, 'data-nb-label-default', label.textContent);
  }

  /* Beder NBCart om sections-payload, så /cart/add.js returnerer den færdige
     drawer-HTML i samme svar — ét kald i stedet for tre. */
  function withSections(payload) {
    var cart = window.NBCart;
    if (cart && typeof cart.sectionsPayload === 'function') {
      var extra = cart.sectionsPayload();
      for (var key in extra) {
        if (Object.prototype.hasOwnProperty.call(extra, key)) payload[key] = extra[key];
      }
    }
    return payload;
  }

  function addToCart(root, button) {
    if (!button || button.getAttribute('data-nb-state') === 'adding') return;

    var items = collectItems(root);
    if (!items.length) return;

    showError(root, null);
    setButtonState(button, 'adding');

    // Åbn draweren MED DET SAMME (optimistisk), så den glider ud instant.
    // Indholdet opdateres af cart.refresh() når serveren svarer.
    window.dispatchEvent(new CustomEvent('nb-cart-open'));

    fetch(root.getAttribute('data-nb-add-url') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(withSections({ items: items }))
    })
      .then(function (response) {
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (data) {
            if (!response.ok) {
              var error = new Error('nb-product');
              error.data = data;
              throw error;
            }
            return data;
          });
      })
      .then(function (data) {
        setButtonState(button, 'added');

        var cart = window.NBCart;
        // Svaret indeholder de renderede sektioner — draweren fyldes straks.
        var instant = !!(data && data.sections && cart && typeof cart.apply === 'function' && cart.apply(data.sections));
        var done = cart && typeof cart.get === 'function' ? cart.get() : Promise.resolve(null);

        return done.then(function (payload) {
          window.dispatchEvent(new CustomEvent('nb-cart-updated', { detail: { cart: payload } }));
          if (!instant && cart && typeof cart.refresh === 'function') return cart.refresh();
          return null;
        });
      })
      .then(function () {
        window.setTimeout(function () {
          if (document.contains(button)) setButtonState(button, 'default');
        }, ADDED_FEEDBACK_MS);
      })
      .catch(function (error) {
        setButtonState(button, 'default');
        showError(root, errorText(root, error));
      });
  }

  /* ---------------------------------------------------------------- *
     Binding
     ---------------------------------------------------------------- */
  function bind(root) {
    if (root.__nbBound) return;
    root.__nbBound = true;

    root.__nbVariants = readVariants(root);

    root.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-nb-thumb]');
      if (thumb) {
        event.preventDefault();
        showMedia(root, thumb.getAttribute('data-nb-media-id'));
        return;
      }

      var value = event.target.closest('.nb-pdp__value');
      if (value) {
        event.preventDefault();
        var group = value.closest('[data-nb-option]');
        if (!group) return;
        qsa(group, '.nb-pdp__value').forEach(function (button) {
          var isActive = button === value;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        applyVariant(root);
        return;
      }

      var stepper = event.target.closest('[data-nb-pdp-qty]');
      if (stepper) {
        event.preventDefault();
        var input = qs(root, '[data-nb-pdp-qty-input]');
        if (!input) return;
        var step = parseInt(stepper.getAttribute('data-nb-pdp-qty'), 10) || 0;
        var next = quantityOf(root) + step;
        if (next < 1) next = 1;
        input.value = String(next);
        paintTotal(root, root.__nbVariant);
      }
    });

    root.addEventListener('change', function (event) {
      if (event.target.closest('[data-nb-pdp-qty-input]')) {
        var input = event.target;
        var value = parseInt(input.value, 10);
        if (isNaN(value) || value < 1) input.value = '1';
        paintTotal(root, root.__nbVariant);
        return;
      }
      if (event.target.closest('[data-nb-upsell-input]')) {
        paintTotal(root, root.__nbVariant);
      }
    });

    var form = qs(root, '.nb-pdp__form');
    if (form) {
      form.addEventListener('submit', function (event) {
        var button = qs(root, '[data-nb-pdp-add]');
        if (!button) return; /* uden knap lader vi browseren om det */
        event.preventDefault();
        addToCart(root, button);
      });
    }

    applyVariant(root, { updateUrl: false });
  }

  /* ---------------------------------------------------------------- *
     Sticky bar
     ---------------------------------------------------------------- */
  function initSticky() {
    var bar = document.querySelector('[data-nb-sticky]');
    if (!bar) return;

    var root = document.querySelector('[data-nb-pdp]');
    var anchor = root ? qs(root, '[data-nb-pdp-cta-anchor]') || root : null;

    if (bar.__nbObserver) {
      bar.__nbObserver.disconnect();
      bar.__nbObserver = null;
    }

    if (!anchor || !('IntersectionObserver' in window)) {
      bar.classList.remove('is-visible');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          /* Kun naar knappen er rullet OP forbi toppen af viewporten. */
          var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', passed);
        });
      },
      { threshold: 0 }
    );
    observer.observe(anchor);
    bar.__nbObserver = observer;

    if (bar.__nbBound) return;
    bar.__nbBound = true;

    bar.addEventListener('click', function (event) {
      var button = event.target.closest('[data-nb-sticky-cta]');
      if (!button) return;
      var host = document.querySelector('[data-nb-pdp]');
      if (!host) return;
      event.preventDefault();
      addToCart(host, button);
    });
  }

  /* ---------------------------------------------------------------- *
     Init
     ---------------------------------------------------------------- */
  function init(scope) {
    qsa(scope || document, '[data-nb-pdp]').forEach(bind);
    if (scope && scope.matches && scope.matches('[data-nb-pdp]')) bind(scope);
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();


/* ------------------------------------------------------------------------
   Antals-vaelger (packs) — port af 20.07-temaets cro-bundle-v2.
   1 stk: farven kommer fra produktets almindelige FARVE-vaelger, som KUN
   vises naar 1 stk er valgt. 2/4 stk: farve vaelges pr. enhed i tieren,
   og FARVE-vaelgeren skjules. CTA'en laegger de valgte enkelt-varianter i
   kurven i ét kald; sections-payload giver instant drawer via NBCart.
   Ingen dansk tekst her — alle strenge kommer fra data-attributter.
   ------------------------------------------------------------------------ */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__nbPacksBound) return;
    root.__nbPacksBound = true;

    var cta = root.querySelector('[data-nb-packs-add]');
    var ctaLabel = root.querySelector('[data-nb-packs-cta-label]');
    if (!cta || !ctaLabel) return;

    var pdp = root.closest('[data-nb-pdp]');
    var picker = pdp ? pdp.querySelector('.nb-pdp__block--options') : null;

    function i18n(name, fallback) {
      var value = root.getAttribute('data-nb-i18n-' + name);
      return value === null || value === '' ? fallback : value;
    }

    function activePack() {
      return root.querySelector('[data-nb-pack].is-active');
    }

    function unitsOf(pack) {
      return parseInt(pack ? pack.getAttribute('data-nb-pack-units') : '1', 10) || 1;
    }

    /* Den valgte hovedvariant (fra FARVE-vaelgeren) til 1 stk-koeb. */
    function mainVariant() {
      if (pdp && pdp.__nbVariant) return pdp.__nbVariant;
      var available = root.getAttribute('data-nb-pack-default-available') === 'true';
      return { id: root.getAttribute('data-nb-pack-default-variant'), available: available };
    }

    function ensureSwatchDefaults() {
      Array.prototype.forEach.call(root.querySelectorAll('[data-nb-pack-unit]'), function (group) {
        var active = group.querySelector('[data-nb-pack-swatch].is-active');
        if (active && !active.disabled) return;
        if (active) active.classList.remove('is-active');
        var first = group.querySelector('[data-nb-pack-swatch]:not([disabled])');
        if (first) first.classList.add('is-active');
      });
    }

    function syncPicker() {
      if (!picker) return;
      picker.style.display = unitsOf(activePack()) > 1 ? 'none' : '';
    }

    function syncCta() {
      var pack = activePack();
      var units = unitsOf(pack);
      var label = units > 1 ? i18n('cta-many', '').replace('[count]', String(units)) : i18n('cta-one', '');

      var ok;
      if (units > 1) {
        var groups = pack ? pack.querySelectorAll('[data-nb-pack-unit]').length : 0;
        var chosen = pack ? pack.querySelectorAll('[data-nb-pack-swatch].is-active:not([disabled])').length : 0;
        ok = !!pack && groups > 0 && chosen === groups;
      } else {
        var variant = mainVariant();
        ok = !!(variant && variant.id) && variant.available !== false;
      }

      cta.disabled = !ok;
      ctaLabel.textContent = ok ? label : i18n('soldout', label);
    }

    function select(pack) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-nb-pack]'), function (p) {
        var on = p === pack;
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      syncPicker();
      syncCta();
    }

    root.addEventListener('click', function (event) {
      var swatch = event.target.closest('[data-nb-pack-swatch]');
      if (swatch && root.contains(swatch)) {
        if (swatch.disabled) return;
        var group = swatch.closest('[data-nb-pack-unit]');
        Array.prototype.forEach.call(group.querySelectorAll('[data-nb-pack-swatch]'), function (s) {
          s.classList.remove('is-active');
        });
        swatch.classList.add('is-active');
        select(swatch.closest('[data-nb-pack]'));
        return;
      }
      var pack = event.target.closest('[data-nb-pack]');
      if (pack && root.contains(pack)) select(pack);
    });

    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var pack = event.target.closest('[data-nb-pack]');
      if (!pack) return;
      event.preventDefault();
      select(pack);
    });

    cta.addEventListener('click', function () {
      if (cta.disabled || cta.getAttribute('data-nb-state') === 'adding') return;
      var pack = activePack();
      if (!pack) return;

      var items = [];
      if (unitsOf(pack) > 1) {
        var counts = {};
        Array.prototype.forEach.call(pack.querySelectorAll('[data-nb-pack-swatch].is-active:not([disabled])'), function (s) {
          var id = s.getAttribute('data-nb-variant-id');
          if (id) counts[id] = (counts[id] || 0) + 1;
        });
        items = Object.keys(counts).map(function (id) {
          return { id: id, quantity: counts[id] };
        });
      } else {
        var variant = mainVariant();
        if (variant && variant.id) items = [{ id: String(variant.id), quantity: 1 }];
      }
      if (!items.length) return;

      var errorEl = root.querySelector('[data-nb-packs-error]');
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.hidden = true;
      }

      var idleLabel = ctaLabel.textContent;
      cta.setAttribute('data-nb-state', 'adding');
      ctaLabel.textContent = i18n('adding', idleLabel);

      // Draweren aabnes med det samme; indholdet foelger i svaret (sections).
      window.dispatchEvent(new CustomEvent('nb-cart-open'));

      var payload = { items: items };
      var cartApi = window.NBCart;
      if (cartApi && typeof cartApi.sectionsPayload === 'function') {
        var extra = cartApi.sectionsPayload();
        for (var key in extra) {
          if (Object.prototype.hasOwnProperty.call(extra, key)) payload[key] = extra[key];
        }
      }

      fetch((root.getAttribute('data-nb-add-url') || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response
            .json()
            .catch(function () { return {}; })
            .then(function (data) {
              if (!response.ok) {
                var error = new Error('nb-packs');
                error.data = data;
                throw error;
              }
              return data;
            });
        })
        .then(function (data) {
          var instant = !!(data && data.sections && cartApi && typeof cartApi.apply === 'function' && cartApi.apply(data.sections));
          if (!instant && cartApi && typeof cartApi.refresh === 'function') cartApi.refresh();
          if (cartApi && typeof cartApi.get === 'function') {
            cartApi.get().then(function (cart) {
              window.dispatchEvent(new CustomEvent('nb-cart-updated', { detail: { cart: cart || null } }));
            });
          }
          ctaLabel.textContent = i18n('added', idleLabel);
          window.setTimeout(function () {
            cta.removeAttribute('data-nb-state');
            syncCta();
          }, 1600);
        })
        .catch(function (error) {
          cta.removeAttribute('data-nb-state');
          syncCta();
          if (errorEl) {
            var message = error && error.data && (error.data.description || error.data.message);
            errorEl.textContent = message || i18n('error', '');
            errorEl.hidden = false;
          }
        });
    });

    var timer = root.querySelector('[data-nb-packs-timer]');
    if (timer) {
      var tick = function () {
        var now = new Date();
        var midnight = new Date(now);
        midnight.setHours(24, 0, 0, 0);
        var diff = Math.max(0, midnight - now);
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        timer.textContent = (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      };
      tick();
      window.setInterval(tick, 1000);
    }

    ensureSwatchDefaults();
    syncPicker();
    syncCta();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-nb-packs]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
